import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";

/**
 * 用户登出接口的请求参数
 */
export interface ILogoutParams extends IRequestParams {}

/**
 * 用户登出接口的返回结果
 */
export interface ILogoutResult extends IResultContent {
    is_ok: boolean;
    msg: string;
}

/**
 * 用户登出
 * @param opts 请求选项
 * @returns 登出结果
 */
export async function logout(opts: IRequestOptions<ILogoutParams> = { params: {} }) {
    const res = await request<ILogoutResult>(
        tms.TUser,
        tms.MUserLogout,
        opts.params,
        opts.gateway,
        opts.handler
    );
    return res;
}

export default logout;
